/* eslint-disable no-shadow */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FavoriteButton from '../FavoriteButton';
import Icon from '../Icon';
import Link from '../Link';
import Rating from '../Rating';
import MapMarker from '../../svg/icons/ic_location_20x20.svg';
import { selectIsAuthenticated } from '../../reducers/authTokenSlice';
import {
  MODAL_MODES,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
  setMultiStepModalVenueId,
  setMultiStepModalVenueContext,
} from '../../reducers/favoriteSlice';

import './AlgorithmicListCard.scss';

const AlgorithmicListCard = ({
  collectionName,
  cuisine,
  href,
  id,
  image,
  isAuthenticated,
  isFavorite,
  locality,
  name,
  neighborhood,
  price,
  rating,
  ratings,
  setMultiStepModalMode,
  setMultiStepModalOpenState,
  setMultiStepModalVenueId,
  setMultiStepModalVenueContext,
  showAuthModal,
}) => {
  const withCollectionParam = (hrefValue) => {
    if (!collectionName) {
      return hrefValue;
    }
    const separator = hrefValue.includes('?') ? '&' : '?';
    return `${hrefValue}${separator}collection=${encodeURIComponent(collectionName)}`;
  };

  const handleHeartIconClick = () => {
    const showMultiListModal = () => {
      setMultiStepModalVenueContext({ name, city: locality });
      setMultiStepModalVenueId(id);
      setMultiStepModalMode(MODAL_MODES.ADD_TO_LIST);
      setMultiStepModalOpenState(true);
    };

    if (isAuthenticated) {
      showMultiListModal();
    } else {
      showAuthModal(showMultiListModal);
    }
  };
  const renderSaveButton = () => (
    <div className="AlgorithmicListCard__saveButton">
      <FavoriteButton
        height={20}
        isLeaderboard
        on={isFavorite}
        onFavoriteClick={handleHeartIconClick}
        venueName={name}
        width={20}
      />
    </div>
  );
  return (
    <div className="AlgorithmicListCard">
      <div className="ResyListCard">
        <div className="ResyListCard__image" style={{ backgroundImage: `url('${image}')` }}>
          <div className={cx({ 'skeleton-animation': !image && image !== null })} />
        </div>

        <div className="ResyListCard__content">
          <div className={cx('ResyListCard__name', { skeleton: !name })}>
            <Link className="ResyListCard__name--link" href={withCollectionParam(href)}>
              <h3 className="ResyListCard__name color--text-primary">
                {name}
              </h3>
            </Link>
          </div>

          <div className={cx('ResyListCard__details body--xs color--text-secondary', { skeleton: !name })}>

            <Rating totalRatings={ratings} score={rating} />

            <div className={cx('separator', { skeleton: !cuisine })} />
            <div className={cx('ResyListCard__details__cuisine', { skeleton: !cuisine })}>{cuisine}</div>
            <div className={cx('separator', { skeleton: !cuisine })} />

            <div className={cx({ skeleton: !price })}>{price}</div>
          </div>
          <div className={cx('ResyListCard__details body--xs color--text-secondary', { skeleton: !name })}>
            <Icon
              component={MapMarker}
              name="MapMarker"
              className="ResyIcon ResyIcon--marker"
              height="14"
              width="14"
              aria-hidden
            />
            <div className={cx('ResyListCard__details__neighborhood', { skeleton: !neighborhood })}>{neighborhood}</div>
          </div>
        </div>
        {renderSaveButton()}
      </div>
    </div>
  );
};

AlgorithmicListCard.propTypes = {
  collectionName: PropTypes.string,
  cuisine: PropTypes.string,
  href: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  image: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  locality: PropTypes.string,
  name: PropTypes.string,
  neighborhood: PropTypes.string,
  price: PropTypes.string,
  rating: PropTypes.number,
  ratings: PropTypes.number,
  setMultiStepModalOpenState: PropTypes.func.isRequired,
  setMultiStepModalVenueContext: PropTypes.func.isRequired,
  setMultiStepModalVenueId: PropTypes.func.isRequired,
  setMultiStepModalMode: PropTypes.func.isRequired,
  showAuthModal: PropTypes.func.isRequired,
};

AlgorithmicListCard.defaultProps = {
  collectionName: undefined,
  cuisine: undefined,
  image: undefined,
  locality: undefined,
  name: undefined,
  neighborhood: undefined,
  price: undefined,
  rating: undefined,
  ratings: undefined,
};

const mapStateToProps = (state, props) => {
  const isAuthenticated = selectIsAuthenticated(state);
  return {
    isAuthenticated,
    isFavorite: !!(state.favoriteVenues.venuesByUser[props.id]),
  };
};

const mapDispatchToProps = ({
  setMultiStepModalMode,
  setMultiStepModalOpenState,
  setMultiStepModalVenueContext,
  setMultiStepModalVenueId,
});

export { AlgorithmicListCard as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(AlgorithmicListCard);
